var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_4283)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6428 45C12.0944 45 11.5459 44.7837 11.1282 44.3532C10.2906 43.4902 10.2906 42.0951 11.1282 41.232L29.3265 22.4716L11.1304 3.77074C10.2927 2.90987 10.2906 1.5126 11.1261 0.649523C11.9615 -0.213559 13.3176 -0.217974 14.1552 0.645108L33.8702 20.9066C34.2729 21.3215 34.5 21.8822 34.5 22.4672C34.5 23.0543 34.2751 23.615 33.8723 24.03L14.1573 44.3532C13.7396 44.7837 13.1912 45 12.6428 45Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_4283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#323232"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.5ff48cb13ce549816169256ff284a07e.svg";
export { ForwardRef as ReactComponent };